import React, { useState, useEffect } from 'react';
import CampoBuscarClub from '../UI/campos/CampoBuscarClub.js';
import CampoBuscarEquipo from '../UI/campos/CampoBuscarEquipo.js';
import ComboSelector from '../UI/campos/ComboSelector.js';
import CuadroDatos from '../UI/CuadroDatos.js';
import * as TipoRival from '../constantes/TipoRival.js';
import * as Categorias from '../constantes/Categorias.js';
import { PreFiltro } from '../data/DataClubes.js';
import { PreFiltro as PreFiltroEquipo } from '../data/DataEquipos.js';
import * as Funciones from '../funciones/FuncionesHistoriales.js';
import * as DataSelecciones from '../data/DataSeleccionesRivales.js';
import styles from './SelectorRivalEnfrentamientos.module.css';

const listaCategorias = [
  { id: null, descripcion: 'Todas' },
  { id: Categorias.MAYOR, descripcion: 'Mayor' },
];

const tiposInternacional = [
  { id: 'A', descripcion: 'Absoluto' },
  { id: null, descripcion: 'Todos' },
];

const SelectorRivalEnfrentamientos = (props) => {
  const [tipoRival, setTipoRival] = useState(Funciones.EncontrarRival(TipoRival.SELECCION));
  const [modoTotales, setModoTotales] = useState(true);

  const [clubRival, setClubRival] = useState(null);
  const [categoriaClub, setCategoriaClub] = useState(listaCategorias[1]);
  const [equipoRival, setEquipoRival] = useState(null);
  const [categoriaEquipo, setCategoriaEquipo] = useState(listaCategorias[1]);
  const [paisSeleccion, setPaisSeleccion] = useState(null);
  const [categoriaSeleccion, setCategoriaSeleccion] = useState(listaCategorias[1]);
  const [tipoInternacional, setTipoInternacional] = useState(tiposInternacional[0]);
  const [listaSelecciones, setListaSelecciones] = useState([]);
  const [isCargandoSelecciones, setIsCargandoSelecciones] = useState(false);

  const idPais = props.idPais;
  const tipoRivalId = tipoRival?.id;
  const mostrarTipoInternacional =
    tipoRivalId === TipoRival.SELECCION && categoriaSeleccion?.id === Categorias.MAYOR;

  useEffect(() => {
    if (tipoRivalId !== TipoRival.SELECCION || !idPais || !categoriaSeleccion?.id) {
      setListaSelecciones([]);
      return;
    }
    setIsCargandoSelecciones(true);
    const tipoIntl = mostrarTipoInternacional ? tipoInternacional : null;
    DataSelecciones.GetSeleccionesRivales(idPais, categoriaSeleccion, tipoIntl).then((lista) => {
      setListaSelecciones(lista || []);
      setIsCargandoSelecciones(false);
    });
  }, [tipoRivalId, idPais, categoriaSeleccion, tipoInternacional, mostrarTipoInternacional]);

  useEffect(() => {
    setPaisSeleccion(null);
  }, [tipoRivalId, categoriaSeleccion, tipoInternacional]);

  const categoriaActual =
    tipoRivalId === TipoRival.CLUB
      ? categoriaClub
      : tipoRivalId === TipoRival.EQUIPO
        ? categoriaEquipo
        : categoriaSeleccion;

  const onTipoRivalElegido = (tipoElegido) => {
    setTipoRival(tipoElegido);
    setModoTotales(true);
  };

  const onCategoriaElegida = (categoriaElegida) => {
    if (tipoRivalId === TipoRival.CLUB) setCategoriaClub(categoriaElegida);
    else if (tipoRivalId === TipoRival.EQUIPO) setCategoriaEquipo(categoriaElegida);
    else setCategoriaSeleccion(categoriaElegida);
  };

  const getLabelRival = () => {
    if (tipoRivalId === TipoRival.SELECCION) return 'País Rival';
    return `${tipoRival?.descripcion} Rival`;
  };

  const onBuscar = () => {
    const rival = modoTotales
      ? null
      : tipoRivalId === TipoRival.CLUB
        ? clubRival
        : tipoRivalId === TipoRival.EQUIPO
          ? equipoRival
          : paisSeleccion;
    if (props.onBuscar) {
      props.onBuscar({
        tipoRivalId,
        modoTotales,
        categoria: categoriaActual,
        tipoInternacional: mostrarTipoInternacional ? tipoInternacional : null,
        rival,
      });
    }
  };

  const buscarDeshabilitado =
    !modoTotales &&
    ((tipoRivalId === TipoRival.CLUB && !clubRival) ||
      (tipoRivalId === TipoRival.EQUIPO && !equipoRival) ||
      (tipoRivalId === TipoRival.SELECCION && !paisSeleccion));

  return (
    <CuadroDatos titulo="Rival" isCargando={false} errores={false}>
      <div className={`${styles.contenedor}`}>
        <span className={`${styles.titulo}`}>Tipo Rival</span>
        <ComboSelector
          lista={Funciones.TiposRival}
          valorActual={tipoRival}
          campoClave={'id'}
          campoDescripcion={'descripcion'}
          isCargando={false}
          onItemElegido={onTipoRivalElegido}
        />

        <div className={`${styles.opciones}`}>
          <label className={`${styles.opcion}`}>
            <input type="radio" checked={modoTotales} onChange={() => setModoTotales(true)} />
            Totales
          </label>
          <label className={`${styles.opcion}`}>
            <input type="radio" checked={!modoTotales} onChange={() => setModoTotales(false)} />
            {getLabelRival()}
          </label>
        </div>

        {!modoTotales && tipoRivalId === TipoRival.CLUB && (
          <React.Fragment>
            <span className={`${styles.titulo}`}>Club Rival</span>
            <CampoBuscarClub
              prefiltro={PreFiltro.SELECCION_RIVAL}
              objetoFiltro={{ idPais, categoria: categoriaClub }}
              nombre={TipoRival.CLUB}
              valor={clubRival}
              editar={true}
              width="100%"
              onClubElegido={(campo, c) => setClubRival(c || null)}
            />
          </React.Fragment>
        )}
        {!modoTotales && tipoRivalId === TipoRival.EQUIPO && (
          <React.Fragment>
            <span className={`${styles.titulo}`}>Equipo Rival</span>
            <CampoBuscarEquipo
              prefiltro={PreFiltroEquipo.SELECCION_RIVAL}
              objetoFiltro={{ idPais, categoria: categoriaEquipo }}
              nombre={TipoRival.EQUIPO}
              valor={equipoRival}
              editar={true}
              width="100%"
              onEquipoElegido={(campo, e) => setEquipoRival(e || null)}
            />
          </React.Fragment>
        )}
        {!modoTotales && tipoRivalId === TipoRival.SELECCION && (
          <React.Fragment>
            <span className={`${styles.titulo}`}>País Rival</span>
            <ComboSelector
              lista={listaSelecciones}
              valorActual={paisSeleccion}
              campoClave={'id'}
              campoDescripcion={'nombre'}
              isCargando={isCargandoSelecciones}
              onItemElegido={(p) => setPaisSeleccion(p || null)}
            />
          </React.Fragment>
        )}

        <span className={`${styles.titulo}`}>Categoría</span>
        <ComboSelector
          lista={listaCategorias}
          valorActual={categoriaActual}
          campoClave={'id'}
          campoDescripcion={'descripcion'}
          isCargando={false}
          onItemElegido={onCategoriaElegida}
        />

        {mostrarTipoInternacional && (
          <React.Fragment>
            <span className={`${styles.titulo}`}>Tipo Internacional</span>
            <ComboSelector
              lista={tiposInternacional}
              valorActual={tipoInternacional}
              campoClave={'id'}
              campoDescripcion={'descripcion'}
              isCargando={false}
              onItemElegido={(t) => setTipoInternacional(t)}
            />
          </React.Fragment>
        )}

        <button
          className={`${styles.botonBuscar}`}
          disabled={buscarDeshabilitado}
          onClick={onBuscar}
        >
          Buscar
        </button>
      </div>
    </CuadroDatos>
  );
};

export default SelectorRivalEnfrentamientos;
